"use client";
import { jsx as e } from "react/jsx-runtime";
import i from "../../common/components/popover/PopoverPortal.js";
const o = ({ children: t, ...p }) => /* @__PURE__ */ e(i, { ...p, feType: "tooltip", children: t });
o.displayName = "Tooltip";
const s = o;
export {
  s as default
};
